<template>
    <div>
        ZAGLUSHKA Landings
    </div>
</template>

<script>
export default {
    name: "Landings"
}
</script>

<style scoped>

</style>
